import React, { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PhoneIcon from "@mui/icons-material/Phone";
import { CssBaseline, Menu, MenuItem } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import BadgeIcon from "@mui/icons-material/Badge";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation, useNavigate } from "react-router-dom";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import "./Admin_Base.css";
import { ToastContainer } from "react-toastify";
import { useAuth } from "../Auth/useAuth";
import { Tooltip } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const Base = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { admin } = useAuth();
  const fullName = admin?.fullName;
  
  const [isOpen, setIsOpen] = useState(() => {
    const savedSidebarState = localStorage.getItem("sidebarOpen");
    return savedSidebarState ? JSON.parse(savedSidebarState) : false;
  });

  const [openareapricedetails, setopenAreaPriceDetails] = useState(
    currentPath.includes("/admin/add_area") ||
    currentPath.includes("/admin/area_list") ||
    currentPath.includes("/admin/add_plot_grid") ||
    currentPath.includes("/admin/plot_list")
  );

  const [opencustomersection, setOpenCustomerSection] = useState(
    currentPath.includes("/admin/CreateCustomer") ||
    currentPath.includes("/admin/Customerlist")
  );
  
  const [opencustomersproperty, setOpenCustomersProperty] = useState(
    currentPath.includes("/admin/customer_requested_property") ||
    currentPath.includes("/admin/customer_property_list") ||
    currentPath.includes("/admin/add_customer_property") ||
    currentPath.includes("/admin/customer_property_rejected_list")
  );
  
  const [openAccount, setOpenAccount] = useState(false);

  const [openemployeesection, setopenemployeesection] = useState(
    currentPath.includes("/admin/admin_add_employee") ||
    currentPath.includes("/admin/admin_employeelist") ||
    currentPath.includes("/admin/admin_employee_tree") ||
    currentPath.includes("/admin/admin_employee_transactions_incentiveslist") ||
    currentPath.includes("/admin/admin_employee_walletwithdraw_requests") ||
    currentPath.includes("/admin/admin_employee_walletwithdraw_list") ||
    currentPath.includes("/admin/admin_employee_percentage") ||
    currentPath.includes("/admin/admin_employee_wallet_Amount")
  );

  const [openavailableproperties, setOpenAvailableProperties] = useState(false);
  
  const [openinvoiceandpayments, setOpenInvoiceAndPayments] = useState(
    currentPath.includes("/admin/Add_Manual_PaymentReciepts") ||
    currentPath.includes("/admin/Manualinvoice_list") ||
    currentPath.includes("/admin/Monthly_scheduled") ||
    currentPath.includes("/admin/Payments_History") ||
    currentPath.includes("/admin/Manualpaymentreciept_list") ||
    currentPath.includes("/admin/PaymentsReceived_when_GatewayisDown")
  );

  const [opencustomersquery, setOpenCustomersQuery] = useState(
    currentPath.includes("/admin/Customers_Queries")
  );

  const toggleSidebar = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    localStorage.setItem("sidebarOpen", JSON.stringify(newIsOpen));
  };

  const handlAreaPriceDetailsClick = () => setopenAreaPriceDetails(!openareapricedetails);
  const handleCustomerSectionClick = () => setOpenCustomerSection(!opencustomersection);
  const handleAccountClick = () => setOpenAccount(!openAccount);
  const handleCustomerPropertyClick = () => setOpenCustomersProperty(!opencustomersproperty);
  const handleEmployeeSectionClick = () => setopenemployeesection(!openemployeesection);
  const handleAvailableProperiesClick = () => setOpenAvailableProperties(!openavailableproperties);
  const handleInvoiceAndPaymentsClick = () => setOpenInvoiceAndPayments(!openinvoiceandpayments);
  const handleCustomersQueriesClick = () => setOpenCustomersQuery(!opencustomersquery);

  useEffect(() => {
    const storedSidebarState = localStorage.getItem("sidebarOpen");
    if (storedSidebarState) {
      setIsOpen(JSON.parse(storedSidebarState));
    }
  }, []);

  const getLinkStyles = (path) => ({
    backgroundColor: currentPath === path ? "#99cccc" : "transparent",
    fontWeight: currentPath === path ? "bold" : "normal",
    borderRadius: "20px",
    color: "#000",
    marginTop: "5px",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlelogout = () => {
    logout();
  };

  // Function to render sidebar content based on user role
  const renderSidebarContent = () => {
    if (fullName === 'super_admin') {
      return (
        <>
          {/* Dashboard */}
          <ListItem
            button
            component="a"
            href="/admin/dashboard"
            className="list-item-main"
            sx={getLinkStyles("/dashboard")}
          >
            <Tooltip title={!isOpen ? "Dashboard" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <HomeIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Dashboard</Typography>}
              />
            )}
          </ListItem>

          {/* Area Price Details */}
          <ListItem
            button
            onClick={handlAreaPriceDetailsClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Area Price Details" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <RequestQuoteOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Area Price Details</Typography>}
              />
            )}
            {isOpen && (openareapricedetails ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openareapricedetails && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/add_area"
                className="list-item"
                sx={getLinkStyles("/admin/add_area")}
              >
                <ListItemText primary={<Typography variant="body2">Add Area</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/area_list"
                className="list-item"
                sx={getLinkStyles("/admin/area_list")}
              >
                <ListItemText primary={<Typography variant="body2">Area List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/add_plot_grid"
                className="list-item"
                sx={getLinkStyles("/admin/add_plot_grid")}
              >
                <ListItemText primary={<Typography variant="body2">Add Plot to Grid</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/plot_list"
                className="list-item"
                sx={getLinkStyles("/admin/plot_list")}
              >
                <ListItemText primary={<Typography variant="body2">Plot List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customer Section */}
          <ListItem
            button
            onClick={handleCustomerSectionClick}
            component="a"
            href={isOpen ? undefined : "/admin/Customerlist"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customer Section" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <PeopleOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customer Section</Typography>}
              />
            )}
            {isOpen && (opencustomersection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersection && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/CreateCustomer"
                className="list-item"
                sx={getLinkStyles("/admin/CreateCustomer")}
              >
                <ListItemText primary={<Typography variant="body2">Create Customer</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Customerlist"
                className="list-item"
                sx={getLinkStyles("/admin/Customerlist")}
              >
                <ListItemText primary={<Typography variant="body2">Customer List</Typography>} />
              </ListItem>
               <ListItem
                button
                component="a"
                href="/admin/add_thirty_percent_for_customer"
                className="list-item"
                sx={getLinkStyles("/admin/add_thirty_percent_for_customer")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Thirty Percent</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/get_thirty_percent_for_customer"
                className="list-item"
                sx={getLinkStyles("/admin/get_thirty_percent_for_customer")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Thirty Percent List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customer Property */}
          <ListItem
            button
            onClick={handleCustomerPropertyClick}
            component="a"
            href={isOpen ? undefined : "/admin/customer_property_list"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customer Property" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <WarehouseIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customers Property</Typography>}
              />
            )}
            {isOpen && (opencustomersproperty ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersproperty && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/customer_requested_property"
                className="list-item"
                sx={getLinkStyles("/admin/customer_requested_property")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Requested property</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/customer_property_list"
                className="list-item"
                sx={getLinkStyles("/admin/customer_property_list")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Property List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/add_customer_property"
                className="list-item"
                sx={getLinkStyles("/admin/add_customer_property")}
              >
                <ListItemText primary={<Typography variant="body2">Add Customer Property</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/customer_property_rejected_list"
                className="list-item"
                sx={getLinkStyles("/admin/customer_property_rejected_list")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Property Rejected List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Employee Section */}
          <ListItem
            button
            onClick={handleEmployeeSectionClick}
            component="a"
            href={isOpen ? undefined : "/admin/admin_add_employee"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Employee Section" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <BadgeIcon sx={{ fontSize: 30 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Employee Section</Typography>}
              />
            )}
            {isOpen && (openemployeesection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openemployeesection && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/admin_add_employee"
                className="list-item"
                sx={getLinkStyles("/admin/admin_add_employee")}
              >
                <ListItemText primary={<Typography variant="body2">Add Employee</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employeelist"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employeelist")}
              >
                <ListItemText primary={<Typography variant="body2">Employee List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_tree"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_tree")}
              >
                <ListItemText primary={<Typography variant="body2">Employee Tree</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_addemployee_walletamount"
                className="list-item"
                sx={getLinkStyles("/admin/admin_addemployee_walletamount")}
              >
                <ListItemText primary={<Typography variant="body2">Add Employees Wallet Amount</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_transactions_incentiveslist"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_transactions_incentiveslist")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Transaction Incentive List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_walletwithdraw_requests"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_walletwithdraw_requests")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet withdraw requests</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_walletwithdraw_list"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_walletwithdraw_list")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet withdraw list</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_percentage"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_percentage")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Percentage</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_wallet_Amount"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_wallet_Amount")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet Amount</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Available Properties */}
          <ListItem
            button
            onClick={handleAvailableProperiesClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Available Properties" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <AssuredWorkloadIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Available Properties</Typography>}
              />
            )}
            {isOpen && (openavailableproperties ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openavailableproperties && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Rajasree Township</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Future Green City</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Sai Kesava</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Invoice And Payments */}
          <ListItem
            button
            onClick={handleInvoiceAndPaymentsClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Invoice And Payments" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <ReceiptOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Invoice And Payments</Typography>}
              />
            )}
            {isOpen && (openinvoiceandpayments ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openinvoiceandpayments && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/Add_Manual_PaymentReciepts"
                className="list-item"
                sx={getLinkStyles("/admin/Add_Manual_PaymentReciepts")}
              >
                <ListItemText primary={<Typography variant="body2">Add Manual Payments Reciepts</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Manualpaymentreciept_list"
                className="list-item"
                sx={getLinkStyles("/admin/Manualpaymentreciept_list")}
              >
                <ListItemText primary={<Typography variant="body2">Manual PaymentReciept list</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Payments_History"
                className="list-item"
                sx={getLinkStyles("/admin/Payments_History")}
              >
                <ListItemText primary={<Typography variant="body2">Payments History</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Monthly_scheduled"
                className="list-item"
                sx={getLinkStyles("/admin/Monthly_scheduled")}
              >
                <ListItemText primary={<Typography variant="body2">Monthly scheduled List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/PaymentsReceived_when_GatewayisDown"
                className="list-item"
                sx={getLinkStyles("/admin/PaymentsReceived_when_GatewayisDown")}
              >
                <ListItemText primary={<Typography variant="body2">Payments Received when Gateway is Down</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customers Queries */}
          <ListItem
            button
            onClick={handleCustomersQueriesClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customers Queries" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <SupportAgentIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customers Queries</Typography>}
              />
            )}
            {isOpen && (opencustomersquery ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersquery && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/Customers_Queries"
                className="list-item"
                sx={getLinkStyles("/admin/Customers_Queries")}
              >
                <ListItemText primary={<Typography variant="body2">Customers Queries</Typography>} />
              </ListItem>
            </List>
          </Collapse>
        </>
      );
    } else if (fullName === 'Accounts') {
      return (
        <>
          {/* Dashboard */}
          <ListItem
            button
            component="a"
            href="/admin/dashboard"
            className="list-item-main"
            sx={getLinkStyles("/dashboard")}
          >
            <Tooltip title={!isOpen ? "Dashboard" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <HomeIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Dashboard</Typography>}
              />
            )}
          </ListItem>

          {/* Invoice And Payments (only for accounts) */}
          <ListItem
            button
            onClick={handleInvoiceAndPaymentsClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Invoice And Payments" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <ReceiptOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Invoice And Payments</Typography>}
              />
            )}
            {isOpen && (openinvoiceandpayments ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openinvoiceandpayments && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/Add_Manual_PaymentReciepts"
                className="list-item"
                sx={getLinkStyles("/admin/Add_Manual_PaymentReciepts")}
              >
                <ListItemText primary={<Typography variant="body2">Add Manual Payments Reciepts</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Manualpaymentreciept_list"
                className="list-item"
                sx={getLinkStyles("/admin/Manualpaymentreciept_list")}
              >
                <ListItemText primary={<Typography variant="body2">Manual PaymentReciept list</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Payments_History"
                className="list-item"
                sx={getLinkStyles("/admin/Payments_History")}
              >
                <ListItemText primary={<Typography variant="body2">Payments History</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Monthly_scheduled"
                className="list-item"
                sx={getLinkStyles("/admin/Monthly_scheduled")}
              >
                <ListItemText primary={<Typography variant="body2">Monthly scheduled List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/PaymentsReceived_when_GatewayisDown"
                className="list-item"
                sx={getLinkStyles("/admin/PaymentsReceived_when_GatewayisDown")}
              >
                <ListItemText primary={<Typography variant="body2">Payments Received when Gateway is Down</Typography>} />
              </ListItem>
            </List>
          </Collapse>
        </>
      );
    } else if (fullName === 'Marketing') {
      return (
        <>
          {/* Dashboard */}
          <ListItem
            button
            component="a"
            href="/admin/dashboard"
            className="list-item-main"
            sx={getLinkStyles("/dashboard")}
          >
            <Tooltip title={!isOpen ? "Dashboard" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <HomeIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Dashboard</Typography>}
              />
            )}
          </ListItem>

          {/* Area Price Details */}
          <ListItem
            button
            onClick={handlAreaPriceDetailsClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Area Price Details" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <RequestQuoteOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Area Price Details</Typography>}
              />
            )}
            {isOpen && (openareapricedetails ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openareapricedetails && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/add_area"
                className="list-item"
                sx={getLinkStyles("/admin/add_area")}
              >
                <ListItemText primary={<Typography variant="body2">Add Area</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/area_list"
                className="list-item"
                sx={getLinkStyles("/admin/area_list")}
              >
                <ListItemText primary={<Typography variant="body2">Area List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/add_plot_grid"
                className="list-item"
                sx={getLinkStyles("/admin/add_plot_grid")}
              >
                <ListItemText primary={<Typography variant="body2">Add Plot to Grid</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/plot_list"
                className="list-item"
                sx={getLinkStyles("/admin/plot_list")}
              >
                <ListItemText primary={<Typography variant="body2">Plot List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customer Section */}
          <ListItem
            button
            onClick={handleCustomerSectionClick}
            component="a"
            href={isOpen ? undefined : "/admin/Customerlist"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customer Section" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <PeopleOutlinedIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customer Section</Typography>}
              />
            )}
            {isOpen && (opencustomersection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersection && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/CreateCustomer"
                className="list-item"
                sx={getLinkStyles("/admin/CreateCustomer")}
              >
                <ListItemText primary={<Typography variant="body2">Create Customer</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/Customerlist"
                className="list-item"
                sx={getLinkStyles("/admin/Customerlist")}
              >
                <ListItemText primary={<Typography variant="body2">Customer List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customer Property */}
          <ListItem
            button
            onClick={handleCustomerPropertyClick}
            component="a"
            href={isOpen ? undefined : "/admin/customer_property_list"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customer Property" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <WarehouseIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customers Property</Typography>}
              />
            )}
            {isOpen && (opencustomersproperty ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersproperty && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/customer_requested_property"
                className="list-item"
                sx={getLinkStyles("/admin/customer_requested_property")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Requested property</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/customer_property_list"
                className="list-item"
                sx={getLinkStyles("/admin/customer_property_list")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Property List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/add_customer_property"
                className="list-item"
                sx={getLinkStyles("/admin/add_customer_property")}
              >
                <ListItemText primary={<Typography variant="body2">Add Customer Property</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/customer_property_rejected_list"
                className="list-item"
                sx={getLinkStyles("/admin/customer_property_rejected_list")}
              >
                <ListItemText primary={<Typography variant="body2">Customer Property Rejected List</Typography>} />
              </ListItem>
            </List>
          </Collapse>

           {/* Employee Section */}
          <ListItem
            button
            onClick={handleEmployeeSectionClick}
            component="a"
            href={isOpen ? undefined : "/admin/admin_add_employee"}
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Employee Section" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <BadgeIcon sx={{ fontSize: 30 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Employee Section</Typography>}
              />
            )}
            {isOpen && (openemployeesection ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openemployeesection && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/admin_add_employee"
                className="list-item"
                sx={getLinkStyles("/admin/admin_add_employee")}
              >
                <ListItemText primary={<Typography variant="body2">Add Employee</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employeelist"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employeelist")}
              >
                <ListItemText primary={<Typography variant="body2">Employee List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_tree"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_tree")}
              >
                <ListItemText primary={<Typography variant="body2">Employee Tree</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_addemployee_walletamount"
                className="list-item"
                sx={getLinkStyles("/admin/admin_addemployee_walletamount")}
              >
                <ListItemText primary={<Typography variant="body2">Add Employees Wallet Amount</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_transactions_incentiveslist"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_transactions_incentiveslist")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Transaction Incentive List</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_walletwithdraw_requests"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_walletwithdraw_requests")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet withdraw requests</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_walletwithdraw_list"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_walletwithdraw_list")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet withdraw list</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_percentage"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_percentage")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Percentage</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href="/admin/admin_employee_wallet_Amount"
                className="list-item"
                sx={getLinkStyles("/admin/admin_employee_wallet_Amount")}
              >
                <ListItemText primary={<Typography variant="body2">Employees Wallet Amount</Typography>} />
              </ListItem>
            </List>
          </Collapse>


          {/* Available Properties */}
          <ListItem
            button
            onClick={handleAvailableProperiesClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Available Properties" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <AssuredWorkloadIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Available Properties</Typography>}
              />
            )}
            {isOpen && (openavailableproperties ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={openavailableproperties && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Rajasree Township</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Future Green City</Typography>} />
              </ListItem>
              <ListItem
                button
                component="a"
                href=""
                className="list-item"
                sx={getLinkStyles("")}
              >
                <ListItemText primary={<Typography variant="body2">Content of Sai Kesava</Typography>} />
              </ListItem>
            </List>
          </Collapse>

          {/* Customers Queries */}
          <ListItem
            button
            onClick={handleCustomersQueriesClick}
            component="a"
            className="list-item-main"
          >
            <Tooltip title={!isOpen ? "Customers Queries" : ""} placement="right">
              <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                <SupportAgentIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
              </ListItemIcon>
            </Tooltip>
            {isOpen && (
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Customers Queries</Typography>}
              />
            )}
            {isOpen && (opencustomersquery ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          </ListItem>

          <Collapse in={opencustomersquery && isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component="a"
                href="/admin/Customers_Queries"
                className="list-item"
                sx={getLinkStyles("/admin/Customers_Queries")}
              >
                <ListItemText primary={<Typography variant="body2">Customers Queries</Typography>} />
              </ListItem>
            </List>
          </Collapse>
        </>
      );
    } else {
      // Default view if no role matches
      return (
        <ListItem
          button
          component="a"
          href="/admin/dashboard"
          className="list-item-main"
          sx={getLinkStyles("/dashboard")}
        >
          <Tooltip title={!isOpen ? "Dashboard" : ""} placement="right">
            <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
              <HomeIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
            </ListItemIcon>
          </Tooltip>
          {isOpen && (
            <ListItemText
              primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Dashboard</Typography>}
            />
          )}
        </ListItem>
      );
    }
  };

  return (
    <div className="admin-sidebar" style={{ display: "flex", paddingBottom: "10px" }}>
      <>
        <div
          className={`sidebar ${isOpen ? "open" : ""}`}
          style={{
            width: isOpen ? "269px" : "60px",
            transition: "width",
          }}
        >
          <List className="list" component="nav" style={{ paddingTop: "104px" }}>
            {renderSidebarContent()}
            
            {/* Account Settings (common for all roles) */}
            <ListItem
              button
              onClick={handleAccountClick}
              component="a"
              href={isOpen ? undefined : "/"}
              className="list-item-main"
            >
              <Tooltip title={!isOpen ? "Account Settings" : ""} placement="right">
                <ListItemIcon sx={{ minWidth: "35px", justifyContent: "center" }}>
                  <SettingsIcon sx={{ fontSize: 25 }} className="ds_sidenav_icon" />
                </ListItemIcon>
              </Tooltip>
              {isOpen && (
                <ListItemText
                  primary={<Typography variant="body2" sx={{ fontSize: "1.1rem" }}>Account Settings</Typography>}
                />
              )}
              {isOpen && (openAccount ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
            </ListItem>

            <Collapse in={openAccount && isOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  component="a"
                  href="/admin/admin_changepassword"
                  className="list-item"
                >
                  <ListItemText primary={<Typography variant="body2">Change Password</Typography>} />
                </ListItem>
                <ListItem
                  button
                  component="a"
                  className="list-item"
                  onClick={handlelogout}
                >
                  <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </div>
      </>
      <div
        id="main"
        style={{
          marginLeft: isOpen ? "269px" : "60px",
          flex: 1,
        }}
      >
        <div
          className="navbar"
          style={{
            left: isOpen ? "269px" : "60px",
            zIndex: 10,
          }}
        >
          <MenuIcon
            onClick={toggleSidebar}
            sx={{ fontSize: 30, color: "white", cursor: "pointer" }}
          />

          <div>
            <span className="company_heading">RAJASREE TOWNSHIPS</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <PhoneIcon
              sx={{
                fontSize: 20,
                color: "white",
                marginRight: "5px",
              }}
            />

            <span style={{ color: "white", fontSize: "16px" }}>
              +91 6262666999
            </span>
            <AccountCircleIcon
              sx={{
                fontSize: 30,
                color: "#0DD354",
                cursor: "pointer",
                marginLeft: "80px",
                marginRight: isOpen ? "269px" : "50px",
              }}
              onClick={handleClick}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              sx={{ marginTop: "40px" }}
            >
              <MenuItem>Change Password</MenuItem>
              <MenuItem onClick={handlelogout}>Logout</MenuItem>
            </Menu>
          </div>
        </div>

        <CssBaseline />
        <ToastContainer position="top-right" />
        <section className="main" style={{ overflow: "hidden" }}>
          {children}
        </section>
      </div>
    </div>
  );
};

export default Base;